import * as React from 'react';
import { Glyphicon } from 'react-bootstrap';
import Dropzone, { IInputProps, IPreviewProps, formatBytes, formatDuration, ILayoutProps } from 'react-dropzone-uploader';
import styled from 'styled-components';
import { getDroppedOrSelectedFiles } from 'html5-file-selector';

import 'react-dropzone-uploader/dist/styles.css';

const Layout = ({ input, previews, submitButton, dropzoneProps, files, extra: { maxFiles }, hideBorder }) => {
    return (
        <div>
            <div style={{ border: files.length > 0 && hideBorder == false ? '1px solid #ddd' : '0 none', marginBottom: files.length > 0 ? 5 : 0, borderRadius: 4 }}>{previews}</div>

            <div {...dropzoneProps}>
                {files.length < maxFiles && input}
            </div>

            {files.length > 0 && submitButton}
        </div>
    );
}

// //@ts-ignore
// import cancelImg from 'react-dropdown-uploader/src/assets/cancel.svg'
// //@ts-ignore
// import removeImg from 'react-dropdown-uploader/src/assets/remove.svg'
// //@ts-ignore
// import restartImg from 'react-dropdown-uploader/src/assets/restart.svg'

// const iconByFn = {
//     cancel: { backgroundImage: `url(${cancelImg})` },
//     remove: { backgroundImage: `url(${removeImg})` },
//     restart: { backgroundImage: `url(${restartImg})` },
// }

const Preview = (props: IPreviewProps) => {
    const {
        className,
        imageClassName,
        style,
        imageStyle,
        fileWithMeta: { cancel, remove, restart },
        meta: { name = '', percent = 0, size = 0, previewUrl, status, duration, validationError },
        isUpload,
        canCancel,
        canRemove,
        canRestart,
        extra: { minSizeBytes },
    } = props;

    let title = `${name || '?'}, ${formatBytes(size)}`;

    if (duration) {
        title = `${title}, ${formatDuration(duration)}`;
    }

    if (status === 'error_file_size' || status === 'error_validation') {
        return (
            <div className={className} style={style}>
                <span className='dzu-previewFileNameError'>{title}</span>
                {status === 'error_file_size' && <span>{size < minSizeBytes ? 'File too small' : 'File too big'}</span>}
                {status === 'error_validation' && <span>{String(validationError)}</span>}
                {canRemove && <span className='dzu-previewButton' style={{ backgroundColor: 'green' }} onClick={remove} />}
            </div>
        );
    }

    if (status === 'error_upload_params' || status === 'exception_upload' || status === 'error_upload') {
        title = `${title} (upload failed)`;
    }

    if (status === 'aborted') {
        title = `${title} (cancelled)`;
    }

    return (
        <div className={className} style={style}>
            {previewUrl && (
                <><span className='dzu-previewFileName'>{title}</span><img className={imageClassName} style={imageStyle} src={previewUrl} alt={title} title={title} /></>
            )}

            {!previewUrl && (
                <span className='dzu-previewFileName'>{title}</span>
            )}

            <div className='dzu-previewStatusContainer'>
                {isUpload && (
                    <progress max={100} value={status === 'done' || status === 'headers_received' ? 100 : percent} />
                )}

                {status === 'uploading' && canCancel && (
                    <span className='dzu-previewButton' onClick={cancel}><Glyphicon glyph='remove' /></span>
                )}

                {status !== 'preparing' && status !== 'getting_upload_params' && status !== 'uploading' && canRemove && (
                    <span className='dzu-previewButton' onClick={remove}><Glyphicon glyph='trash' /></span>
                )}

                {['error_upload_params', 'exception_upload', 'error_upload', 'aborted', 'ready'].includes(status) && canRestart &&
                    <span className='dzu-previewButton' style={{ backgroundColor: 'yellow' }} onClick={restart}><Glyphicon glyph='retweet' /></span>
                }
            </div>
        </div>
    )
}

const DropzoneWrapper = styled.div`
    & > div > .dzu-dropzone > .dzu-inputLabel > .dzu-input {
        display: none !important;
    }

    & > .dzu-dropzone > .dzu-inputLabelWithFiles {
        margin-top: 10px;
    }

    & > .dzu-dropzone > .dzu-inputLabelWithFiles > .dzu-input {
        display: none !important;
    }

    & > div > div > .dzu-previewContainer {
        padding: 10px 3%;
        min-height: 40px;
    }

    & > div > .dzu-dropzone {
        overflow: hidden;
        border: 0 none;
        min-height: initial;
    }
`;

const Input = ({ accept, onFiles, files, getFilesFromEvent, style }) => {
    // const text = files.length > 0 ? 'Add more files' : 'Choose files'
    const justifyContent = style ? style.justifyContent : 'flex-end';

    return (
        <div style={{ display: 'flex', justifyContent, width: '100%' }}>
            <label className='btn' style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                <Glyphicon glyph='paperclip' style={{ marginRight: 5 }} />
                {/* {text} */}
                Attach File(s)
                <input
                    style={{ display: 'none' }}
                    type='file'
                    accept={accept}
                    multiple
                    onChange={e => {
                        getFilesFromEvent(e).then(chosenFiles => {
                            onFiles(chosenFiles)
                        })
                    }}
                />
            </label>
        </div>
    );
}

interface MyUploaderProps {
    initialFiles?: File[]
    url?: string,
    style?: {
        justifyContent: string
    },
    hideBorder?: boolean,
    filesChanged: (file: File, status: string) => void
}

const MyUploader = (props: MyUploaderProps) => {
    // called every time a file's `status` changes
    const handleChangeStatus = ({ meta, file }, status, allFiles) => {
        if (status == 'done' || status == 'removed')
            props.filesChanged(file, status);

        if (status == 'headers_received') {
            let index = 0;
            while (allFiles.length) {
                if (allFiles[index].file.name == file.name) {
                    allFiles[index].remove();
                    break;
                }

                index++;
            }
        }
    }

    // receives array of files that are done uploading when submit button is clicked
    const handleSubmit = (files) => { console.log(files.map(f => f.meta)) }

    const getFilesFromEvent = (e: React.DragEvent<HTMLElement> | React.ChangeEvent<HTMLInputElement>): Promise<File[]> | File[] => {
        let results = new Promise(resolve => {
            getDroppedOrSelectedFiles(e).then(chosenFiles => {
                resolve(chosenFiles.map(f => f.fileObject))
            })
        });

        return results as any;
    }

    const getUploadParams = ({ meta }) => {
        return {
            url: props.url
        }
    }

    return (
        <DropzoneWrapper>
            <Dropzone
                InputComponent={(inputProps: IInputProps) => <Input {...inputProps} style={props.style} />}
                onChangeStatus={handleChangeStatus}
                // onSubmit={handleSubmit}
                initialFiles={props.initialFiles}
                accept='*'
                autoUpload={false}
                LayoutComponent={(layoutProps: ILayoutProps) => <Layout {...layoutProps} hideBorder={props.hideBorder} />}
                PreviewComponent={(previewProps: IPreviewProps) => <Preview {...previewProps} />}
                getFilesFromEvent={getFilesFromEvent}
                getUploadParams={props.url ? getUploadParams : null}
            />
        </DropzoneWrapper>
    );
}

export default MyUploader;